import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import Icon from "../UI/Icon";
import Modal from "../UI/Modal";
import CategoryCard from "../UI/CategoryCard";
import * as endpoint from "../../Service/endpoints";
import { NAV_CATEGORIES, getCategoryMeta } from "../User/Catalog/categoryMeta";

// Thumb-reachable navigation for phones and small tablets (hidden ≥1024px).
function BottomNav({ onSearch, cartCount }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const loggedIn = useSelector((state) => state.userState.loggedIn);
  const [categoriesOpen, setCategoriesOpen] = useState(false);
  const city = endpoint.getCurrentCity();
  const segments = location.pathname.split("/").filter(Boolean);
  const isHome = segments.length === 0 || (segments.length === 1 && segments[0] === city);
  const inCatalog = segments.length >= 2 && segments[0] === city;

  useEffect(() => {
    document.body.classList.add("has-bottom-nav");
    return () => document.body.classList.remove("has-bottom-nav");
  }, []);

  useEffect(() => setCategoriesOpen(false), [location.pathname]);

  const categories = [...NAV_CATEGORIES];
  if (city === "gurgaon") categories.push("expressDelivery");

  return (
    <>
      <nav className="v-bottom-nav" aria-label="Quick navigation">
        <Link to={endpoint.getPath("")} className="v-bottom-nav__item" aria-current={isHome ? "page" : undefined}>
          <Icon name="home" size={22} />
          <span>Home</span>
        </Link>
        <button
          type="button"
          className="v-bottom-nav__item"
          aria-current={inCatalog ? "page" : undefined}
          aria-haspopup="dialog"
          onClick={() => setCategoriesOpen(true)}
        >
          <Icon name="layers" size={22} />
          <span>Categories</span>
        </button>
        <button type="button" className="v-bottom-nav__item" aria-haspopup="dialog" onClick={onSearch}>
          <Icon name="search" size={22} />
          <span>Search</span>
        </button>
        <a href="/cart" className="v-bottom-nav__item" aria-current={location.pathname === "/cart" ? "page" : undefined}>
          <span className="v-bottom-nav__icon">
            <Icon name="bag" size={22} />
            {cartCount ? <span className="v-count">{cartCount > 9 ? "9+" : cartCount}</span> : null}
          </span>
          <span>Cart</span>
        </a>
        {loggedIn ? (
          <a href="/account" className="v-bottom-nav__item">
            <Icon name="user" size={22} />
            <span>Account</span>
          </a>
        ) : (
          <button type="button" className="v-bottom-nav__item" onClick={() => dispatch({ type: "login.window.show" })}>
            <Icon name="user" size={22} />
            <span>Sign in</span>
          </button>
        )}
      </nav>

      <Modal open={categoriesOpen} onClose={() => setCategoriesOpen(false)} title="Shop by category" variant="sheet">
        <div className="v-cat-sheet">
          {categories.map((slug) => {
            const meta = getCategoryMeta(slug);
            return (
              <CategoryCard
                key={slug}
                size="sm"
                to={endpoint.getPath(slug)}
                title={meta.short}
                image={meta.image}
              />
            );
          })}
        </div>
      </Modal>
    </>
  );
}

export default BottomNav;
